import { Component, OnInit, ViewChild} from '@angular/core';
import { MenuItems, ObjectNames,Status,Answer, Severity } from '../constants/constants';
import { Subject } from 'rxjs';
import { AssignComponent } from './assign/assign.component';
import { PricebookService } from './pricebook.service';
import { PricingComponent } from './pricing/pricing.component';
import { TitleCasePipe } from '@angular/common';
import { debounceTime } from "rxjs/operators";
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { AppMainComponent } from 'src/app/app.main.component';
import { AppMainService } from 'src/app/app-main.service';
import { CurrencySymbolPipe } from 'src/app/modules/shared/pipes/currency-symbol.pipe';


@Component({
  selector: 'app-pricebook',
  templateUrl: './pricebook.component.html',
  styleUrls: ['./pricebook.component.scss']
})
export class PricebookComponent implements OnInit {

  index=0;
  enable: boolean=false;
  configMenuInventoryItems=[];
  tierForm: FormGroup;
  allTiers=[];
  isDisabled: boolean=false;
  warningText: string='';
  displayProductAvailability: boolean=false;
  associatedProducts: string='';
  isAdd: boolean= true;
  discountGroupType = ObjectNames.priceBooksConstants.DiscountGroupType;
  discountQtyType = ObjectNames.priceBooksConstants.DiscountQtyType;
  statusConstants=Status;
  answertypeConstants = Answer;
  displayPricingAddEdit = false;
  duplicateTier: boolean =false;
  addEditPricingHeader;
  types = [];
  @ViewChild(PricingComponent) priceComponent: PricingComponent;
  @ViewChild(AssignComponent) assignComponent: AssignComponent ;
  productChannels=[];
  // groupTypes = [
  //   {id:1, name:"Discount By Product Group"},
  //   {id:1, name:"Discount By Product Category"},
  //   {id:1, name:"Discount By Manufacturer"},
  // ]

  //pricing table
  displayPricingTB = false;
  totalRecords:number=0;
  totalPages: number=0;
  pricingDataAll = []
  pricingData = [];
  selectedItems=[];
  priceTierList=[];
  pageNumber:number=1;
  first: number=0;
  pageSize:number=15;
  searchValue:string='';
  searchColumns: string='';
  modelChanged = new Subject<string>();
  tiers = [];
  selectedTiers = [];
  wareHouseList=[];
  selectedLocation;
  selectedLevel;
  selectedTier;
  selectedDiscountType;
  category = [];
  manufacturer=[];
  isEdit: boolean=false;
  selectedCategory;
  selectedManufacturer;
  selectedTBChannel;
  noProdcuctsFindOrLoadingText:string='';
  discountType;
  allChecked: boolean=false;
  selectedGroup;
  levels=[
    {id: 1,number: 1},
    {id: 2,number: 2},
    {id: 3,number: 3},
    {id: 4,number: 4},
    {id: 5,number: 5}
  ];

  constructor(private pricebookService: PricebookService,private fb: FormBuilder,private messageService: MessageService,
    private app: AppMainComponent, private titleCasePipe: TitleCasePipe, private confirmationService: ConfirmationService,
     private appService: AppMainService, private currecySymbol: CurrencySymbolPipe,) {
      this.modelChanged.pipe(
        debounceTime(700))
        .subscribe(() => {
         this.onSearch();
      })
     }

  ngOnInit(): void {
    this.configMenuInventoryItems = [
      {
        label:  MenuItems.Pricing,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddPricing();
        }
      },
      {
        label:  MenuItems.AssignPrice,
        icon: 'pi pi-plus',
        command: () => {
          this.showAssignPriceTier();
        }
      },
    ];
    this.loadPriceTiers();
    this.tierForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      name: ['', [Validators.required,Validators.pattern(/^(?!\s*$).+/)]],
      statusId: [true],
      isDefault: [false],
      isCustom: [false],
      isVisible: [true],
      enabled: [true,],
      markup: [null, [Validators.required,Validators.pattern(/^-?[0-9]+(\.[0-9]+)?$/)]],
      organizationId: [this.app.companyId],
      typeId: [null, [Validators.required]],
      order: [3],
      productGroupId: [0],
      productCategoryId: [0]
    })
    this.loadPriceTierGroups();
    this.getProductsChannels('Product');
    this.getInventoryGroups();
    this.getVendor();
    this.getAllWareHouse();
  }

  getIndex(event){
    this.index = event.index;
  }

  showAssignPriceTier(){
    this.index=2;
    this.assignComponent.showAssignPriceTier();
  }

  getProductsChannels(name) {
    this.pricebookService.getConfigurationsByModuleName(name).subscribe(configs => {
      const typeConfig = configs.filter(s => s.name == ObjectNames.productConstants.Inventory_Types_Object)[0];
      this.productChannels = JSON.parse(typeConfig.configurationDetails[0].configJSONValue);
      this.selectedTBChannel = this.productChannels[0];
    });
  }

  getInventoryGroups() {
    this.pricebookService.getInventoryGroupList().subscribe(groups => {
      const productInventoryGroup = groups.filter(s => s.name == ObjectNames.productConstants.productCategoryName)[0];
      this.getInventoryCategory(productInventoryGroup.id);
    });
  }

  getInventoryCategory(groupId) {
    this.pricebookService.getInventoryCategoryList(groupId).subscribe(cats => {
      if(cats){
       this.category= cats.filter(cat=> cat.statusId==Status.ACTIVE);
      }
    });
  }

  getAllWareHouse() {
    this.pricebookService.getAllLocations().subscribe((wHouse) => {
        for(let loc of wHouse){
            loc.customName = loc.name+' - '+loc.locationId;
          }
        this.wareHouseList = wHouse.filter(wh=> wh.statusId==Status.ACTIVE);
        this.selectedLocation = this.wareHouseList?.filter(wh=> wh.isDefault==true)[0];
    });
}


  loadPriceTierGroups(){
    this.pricebookService.getAllPriceTierGroups().subscribe(groups=>{
      const priceTierGroup = groups?.filter(group=> group.name== ObjectNames.priceBooksConstants.PriceTierType)[0];
      this.loadPriceTierTypes(priceTierGroup?.id);
    })
  }

   loadPriceTierTypes(groupId){
    this.pricebookService.getAllPriceTierTypes(groupId).subscribe(types=>{
      this.types=types;
    })
  }

  loadPriceTiers(status?){
    this.appService.isShowSpinner('loadPriceTiers');
    this.pricebookService.getSetPriceTierConfigByVisibility(status, true).subscribe((tiers) => {
      this.enable = tiers.item1;
      this.allTiers = tiers.item2;
      this.appService.isHideSpinner('loadPriceTiers');
    })
  }

  getVendor() {
    this.pricebookService.getvendorsDD().subscribe((vendor) => {
        this.manufacturer = (vendor?.filter(v=> (v.typeName=='Manufacturer' && v.isActive)));
    });
}

  checkDuplicateTierName(){
    const tierId = (this.isAdd?0:this.tierForm.controls['id'].value);
    const name = (this.tierForm.controls['name'].value.trim());
    if(name){
      this.pricebookService.checkDuplicateTier(tierId,name).subscribe(check=>{
        if(check){
         this.duplicateTier = true;
        }else{
         this.duplicateTier = false;
        }
    })
  }
 }

  save(value){
    this.isDisabled=true;
    if(!value.isCustom && value.markup==0){
      this.isDisabled=false;
      this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Markup/Discount should not be 0,either it should be less than zero or greater than 0.' });
    }else{
      value.typeId = value.typeId?.id;
      value.statusId = (value.statusId?Status.ACTIVE:Status.INACTIVE);
      if(value.isCustom){
        value.markup=0;
        value.order =2;
      }
      if(this.isAdd){
        this.pricebookService.addPriceTier(value).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Price Tier Added successfully...' });
          this.loadPriceTiers();
          this.isDisabled=false;
          this.displayPricingAddEdit = false;
        }).catch(() => {
          this.displayPricingAddEdit = false;
          this.isDisabled=false;
          this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }else{
        this.pricebookService.updatePriceTier(value).then((res) => {
          if(res.item1){
            this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Price Tier Updated successfully...' });
            this.loadPriceTiers();
            this.isDisabled=false;
            this.displayPricingAddEdit = false;
          }else{
            this.warningText = "Inactive Warning";
            this.associatedProducts=res.item2;
            this.displayProductAvailability =true;
            this.isDisabled=false;
            this.displayPricingAddEdit = false;
          }
        }).catch(() => {
          this.displayPricingAddEdit = false;
          this.isDisabled=false;
          this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }
    }
  }

  showAddPricing(){
    this.isAdd=true;
    this.isDisabled=false;
    this.duplicateTier = false;
    this.tierForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      name: ['', [Validators.required,Validators.pattern(/^(?!\s*$).+/)]],
      statusId: [true],
      isDefault: [false],
      isCustom: [false],
      isVisible: [true],
      enabled: [true,],
      markup: [null, [Validators.required,Validators.pattern(/^-?[0-9]+(\.[0-9]+)?$/)]], //  /^[0-9-]*$/
      organizationId: [this.app.companyId],
      typeId: [null, [Validators.required]],
      order: [3],
      productGroupId: [0],
      productCategoryId: [0]
    })
    this.addEditPricingHeader = "Add Pricing";
    this.displayPricingAddEdit = true;
  }

  setDiscountValidation(event){
   if(event.checked){
     this.tierForm.controls['markup'].clearValidators();
     this.tierForm.controls['markup'].updateValueAndValidity();
   }else{
     this.tierForm.controls['markup'].addValidators([Validators.required]);
     this.tierForm.controls['markup'].updateValueAndValidity();
   }
  }

  showEditPricing(value){
    this.duplicateTier = false;
    this.addEditPricingHeader = "Edit Pricing";
    this.isAdd=false;
    this.tierForm.patchValue(value);
    const filterDiscountType = this.types?.filter(type=> type.id==value.typeId)[0];
    this.tierForm.controls['typeId'].setValue(filterDiscountType);
    this.tierForm.controls['statusId'].setValue(value.statusId==Status.ACTIVE?true:false);
    this.displayPricingAddEdit = true;
  }

 deleteTier(data){
   const parsedObj = JSON.parse(data);
   this.pricebookService.deletePriceTier(parsedObj?.tier.id).then((res) => {
    if(res.item1){
      this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
      const filteredType = this.allTiers?.filter(tier=> tier.id==parsedObj.type.id)[0];
      // const index = filteredType.childPriceTier?.indexOf(parsedObj?.tier);
      filteredType?.childPriceTier?.splice(parsedObj.index, 1);
    }else{
      this.warningText = "Delete Warning";
      this.associatedProducts=res.item2;
      this.displayProductAvailability =true;
    }
  }).catch(() => {
    this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
  });
 }

 openProducts(c){
  const parsedObj = JSON.parse(c);
  this.allChecked=false;
  this.first=0;
  this.isDisabled=false;
  this.isEdit=false;
  this.selectedDiscountType =parsedObj.discountType;
  this.selectedGroup = parsedObj.group;
  this.discountType = parsedObj.action;
  this.tiers = parsedObj.discountType?.childPriceTier?.filter(tier=> tier.isVisible==true);
  this.pageNumber=1;
  this.pageSize=15;
  this.selectedItems=[];
  this.searchValue='';
  this.selectedCategory=null;
  this.selectedManufacturer=null;
  this.selectedTiers=[];
  this.selectedTier=null;
  this.selectedLocation = this.wareHouseList?.filter(wh=> wh.isDefault==true)[0];
  this.selectedLevel=null;
  this.loadProducts(this.pageNumber,this.pageSize,this.selectedTBChannel?.id,this.selectedDiscountType?.id,null,null,this.selectedLocation?.id,'',null);
}

getData(event){
  this.pageNumber = (event.first / event.rows) + 1;
  this.first= event.first;
  this.loadProducts(this.pageNumber,this.pageSize,this.selectedTBChannel.id,this.selectedDiscountType?.id,this.selectedCategory?.id,this.selectedManufacturer?.id,this.selectedLocation?.id,this.searchValue,this.selectedTier?.id);
}

onTypeChange(){
  this.first=0;
  this.pageNumber=1;
  this.pageSize=15;
  this.selectedCategory=null;
  this.loadProducts(this.pageNumber,this.pageSize,this.selectedTBChannel.id,this.selectedDiscountType?.id,null,null,this.selectedLocation?.id,'',null);
}

addItemToGroup(event,item){
  if(event.checked){
    this.selectedItems.push(item);
  }else{
    const group = this.selectedItems.filter(i=> i.id==item.id)[0];
    group.statusId=3;
  }
}

setProductTiers(tiers,savedTiers){
  const tiersReturn=[];
  savedTiers.forEach(element => {
     const filteredTerm = tiers?.filter(tier=> tier.id==element.tierId)[0];
     filteredTerm.qtyPrice = savedTiers?.filter(tier=> tier.tierId==filteredTerm.id).map(qty=> qty.qtyPrice)[0];
     tiersReturn.push(filteredTerm);
  });
  return tiersReturn;
}

loadProducts(pageNumber,pageSize,typeId,discountTypeId,categoryId,manufacturerId,warehouseId,searchValue,groupId){
  this.appService.isShowSpinner('tier');
  this.pricebookService.getAllItems(pageNumber,pageSize,typeId,discountTypeId,categoryId,manufacturerId,warehouseId,searchValue,groupId).then(products => {
    let { items, headers } = products;
    items = items == null ? [] : items;
    this.priceTierList = items.priceTierList;
    headers = headers == null ? [] : headers;
    this.totalRecords = headers['TotalCount'];
    this.totalPages = headers['TotalPages'];
    if(this.allChecked){
      this.pageSize = this.totalRecords;
    }
    this.pricingDataAll = [];
    this.pricingData = [];
    if(items?.productTier?.length>0){
      for (let l of items?.productTier) {
        const eachItem = {
          id: l.productId,
          itemNo: l.itemNo,
          description: l.itemDescription,
          cost: this.currecySymbol.transform(parseFloat(l.costPrice).toFixed(2)),
          price:this.currecySymbol.transform(parseFloat(l.salesPrice).toFixed(2)),
          productPriceTierName: l.priceTiers,
          savedTiers: l.productPriceTier,
          productPriceTier: this.setProductTiers(this.priceTierList,l.productPriceTier),
          qtyLevel: l.productPriceTier[0]?.qtyLevel,
          statusId: Status.ACTIVE,
          isChecked: ((this.discountType=='addbulkitemtogroup' && l.productPriceTier[0]?.tierId==this.selectedGroup?.id)?true:false)
        }
        this.pricingDataAll.push(eachItem);

        if(this.discountType=='addbulkitemtogroup' && eachItem.isChecked){
          const existingItem = this.selectedItems?.filter(itm=> itm.id==eachItem.id)[0];
          if(!existingItem){
            this.selectedItems.push(eachItem);
          }
        }
      }
      this.pricingData = JSON.parse(JSON.stringify(this.pricingDataAll));
      //console.log(this.pricingData)
      this.pricingData.forEach((element:any) => {
        const alreadyChecked:any = this.selectedItems?.filter((item:any)=> item.id==element.id)[0];
        if(alreadyChecked){
          element.isChecked=true;
          element.productPriceTier=  alreadyChecked.productPriceTier;
          element.qtyLevel=  alreadyChecked.qtyLevel;
        }
      });
      this.appService.isHideSpinner('tier');
      this.displayPricingTB = true;
    }else{
      this.totalRecords=0;
      this.appService.isHideSpinner('tier');
      this.noProdcuctsFindOrLoadingText = 'No Products found.';
    }
  })
}

 changed(event){
  this.modelChanged.next("");
}

onSearch(){
 this.pageNumber=1;
 this.pageSize=15;
 this.first=0;
 this.loadProducts(this.pageNumber,this.pageSize,this.selectedTBChannel.id,this.selectedDiscountType?.id,this.selectedCategory?.id,this.selectedManufacturer?.id,this.selectedLocation?.id,this.searchValue,this.selectedTier?.id);
}

productByCate(){
  this.pageNumber=1;
  this.pageSize=15;
  this.first=0;
  this.searchValue='';
  this.loadProducts(this.pageNumber,this.pageSize,this.selectedTBChannel.id,this.selectedDiscountType?.id,this.selectedCategory?.id,this.selectedManufacturer?.id,this.selectedLocation?.id,this.searchValue,this.selectedTier?.id);
}

productByGroup(){
  this.pageNumber=1;
  this.pageSize=15;
  this.first=0;
  this.searchValue='';
  this.loadProducts(this.pageNumber,this.pageSize,this.selectedTBChannel.id,this.selectedDiscountType?.id,this.selectedCategory?.id,this.selectedManufacturer?.id,this.selectedLocation?.id,this.searchValue,this.selectedTier?.id);
}

productByManufacturer(){
  this.pageNumber=1;
  this.pageSize=15;
  this.first=0;
  this.searchValue='';
  this.loadProducts(this.pageNumber,this.pageSize,this.selectedTBChannel.id,this.selectedDiscountType?.id,this.selectedCategory?.id,this.selectedManufacturer?.id,this.selectedLocation?.id,this.searchValue,this.selectedTier?.id);
}

onChangeTier(item){
  //console.log(item)
  if(item.productPriceTier?.length>0){
    item.isChecked=true;
    const exists = this.selectedItems?.filter((i:any)=> i.id==item.id)[0];
    if(exists){
      const index = this.selectedItems.indexOf(exists);
      //console.log(index)
      this.selectedItems.splice(index,1);
      this.selectedItems.push(item);
    }else{
      this.selectedItems.push(item);
    }
  }else{
    item.isChecked=false;
    const index = this.selectedItems.indexOf(item);
    this.selectedItems.splice(index,1);
  }
  //console.log(this.selectedItems)
}

setBulkProductTiers(){
  const products=[];
    this.selectedItems.forEach((item:any) => {
      item.productPriceTier?.forEach(element => {
        const tierEach={
          id: (item.savedTiers?.filter(t=> t.tierId==element.id).map(tier=> tier.id)[0]?item.savedTiers?.filter(t=> t.tierId==element.id).map(tier=> tier.id)[0]:0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          tierName: element.name,
          qtyLevel: item.qtyLevel,
          order: (element.isCustom?2:3),
          productId: item.id,
          typeId: this.selectedDiscountType?.id,
          warehouseId: this.selectedLocation?.id,
          tierId: element.id,
          markup: element.markup,
          qtyPrice: element.qtyPrice,
          statusId: Status.ACTIVE
        }
        products.push(tierEach);
      });
    });
    //console.log(products)
    return products;
}

setBulkProductGroups(){
  const products=[];
    this.selectedItems.forEach((item:any) => {
      const tierEach={
        id: (item.savedTiers?.filter(t=> t.tierId==this.selectedGroup?.id).map(tier=> tier.id)[0]?item.savedTiers?.filter(t=> t.tierId==this.selectedGroup?.id).map(tier=> tier.id)[0]:0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        tierName: this.selectedGroup?.name,
        qtyLevel: 0,
        order: 3,
        productId: item.id,
        typeId: this.selectedDiscountType?.id,
        warehouseId: this.selectedLocation?.id,
        tierId: this.selectedGroup?.id,
        markup: this.selectedGroup?.markup,
        qtyPrice: '',
        statusId: item.statusId
      }
      products.push(tierEach);
    });
    //console.log(products)
    return products;
}

saveBulkProductTier(){
  this.isDisabled=true;
  let req;
  if(this.discountType!='addbulkitemtogroup'){
    req= this.setBulkProductTiers();
  }else{
    req= this.setBulkProductGroups();
  }
  // console.log(req)
  // return
  if(this.discountType!='addbulkitemtogroup'){
    this.pricebookService.addBulkPriceTier(req).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Updated successfully...' });
      this.isDisabled=false;
      this.displayPricingTB = false;
    }).catch(() => {
      this.displayPricingTB = false;
      this.isDisabled=false;
      this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }else{
    this.pricebookService.addBulkProductToGroup(req).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Updated successfully...' });
      this.isDisabled=false;
      this.displayPricingTB = false;
    }).catch(() => {
      this.displayPricingTB = false;
      this.isDisabled=false;
      this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }
}

applyAll(){
  this.isDisabled=true;
  const tierIds=[];
  this.selectedTiers?.forEach(element => {
   tierIds.push(element.id)
  });
  const ids = tierIds.join(',')
  const req ={
    categoryId : this.selectedCategory?.id,
    typeId: this.selectedTBChannel?.id,
    warehouseId: this.selectedLocation?.id,
    qtyLevelId: this.selectedLevel,
    search:'',
    tierId: ids
  }
  this.pricebookService.applyAllBulkPriceTier(req).then(() => {
    this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Updated successfully...' });
    this.isDisabled=false;
    this.displayPricingTB = false;
  }).catch(() => {
    this.displayPricingTB = false;
    this.isDisabled=false;
    this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
  });
}

setAllProduct(event){
 if(event.checked){
  this.pageNumber=0;
  this.pageSize=0;
  this.first=0;
  this.loadProducts(this.pageNumber,this.pageSize,this.selectedTBChannel.id,this.selectedDiscountType?.id,this.selectedCategory?.id,this.selectedManufacturer?.id,this.selectedLocation?.id,this.searchValue,this.selectedTier?.id);
  setTimeout(() => {
    for(let item of this.pricingData){
      item.isChecked =true;
      this.selectedItems.push(item);
     }
  }, 250);
 }else{
  for(let item of this.pricingData){
    item.isChecked =false;
   }
   this.selectedItems=[];
 }
}

}


